export const global = {}